import { useSafeNavigate } from '../hooks/useSafeNavigate';
import './AutomationSection.scss'
import Title from "./Title";


function AutomationSection({ data }) {

    return (
        <section className="automation position-relative">

            <div className="automation__container pt-5">
                <Title
                    title={
                        "Автоматизация технологических процессов энергетики и промышленности"
                    }
                />
                <div className="container flex-row p-0">
                    <AutomationGrid
                    >
                        {data.map((i) => (
                            <AutomationItem data={i} />
                        ))}
                    </AutomationGrid>
                </div>

            </div>
        </section>
    );
}



export default AutomationSection;

export const AutomationGrid = ({ children }) => {
    return <div className="automation-grid">
        {children}
    </div>
}

export const AutomationItem = ({ data }) => {
    const i = data
    const navigate = useSafeNavigate();
    return <div
        className={`automation__column rounded position-relative ${i.disabled ? 'automation__column_disabled' : ''}`}
        key={i.title}
        style={{
            background: "white",
            overflow: "hidden",
            boxShadow: "1px 1px 5px  #00000030",
        }}
        onClick={() => !i.disabled && navigate(i.link)}
    >
        <div className='position=absolute automation__'>

        </div>
        <div
            style={{
                background:
                    "linear-gradient(90deg, rgba(41, 117, 219, 1) 0%, rgba(242, 110, 89, 1) 97%)",
                height: "6rem",
                marginBottom: "2rem",
                position: "relative",
            }}
        >
            {i.isExpert && (
                <div className="automation__expert_mark">Expert +</div>
            )}
            <img
                className="automation__img"
                src={i.image}
                alt="иконка, которая иллюстрирует промышленность"
                style={{
                    position: "absolute",
                    left: "50%",
                    bottom: "-50%",
                    transform: "translateX(-50%)",
                    width: "4rem",
                    height: "4rem",
                    background: "rgba(242, 110, 89, 1)",
                    border: `3px solid  white`,
                    // background: 'white',
                    // border: `3px solid  ${i.color}`
                }}
            />
        </div>
        <div
            className="d-flex flex-column flex-grow-1"
            style={{ padding: "0.5rem 3rem" }}
        >
            <h4
                className="mt-3"
                style={{ minHeight: "3.5rem", textAlign: "center" }}
            >
                {i.title}
            </h4>

            <p
                className="mt-3 mb-4 flex-grow-1"
                style={{ color: "#00000095", textAlign: "center" }}
            >
                {i.paragraph}
            </p>
            <p
                //to={i.link}
                style={{ color: "rgb(41 117 219)", textAlign: "center" }}
            // className="link"
            >
                {"Варианты использования ->"}
            </p>
        </div>
    </div>
}